import { useState } from "react";
import styled from "styled-components";
import LOGO from "../../assets/Aqua-logo.png";
import { RxHamburgerMenu } from "react-icons/rx";

const Header = () => {
  const [navOpen, setNavOpen] = useState(false);
  const toggleNavbar = () => setNavOpen(!navOpen);

  return (
    <TheHeader>
      <div className="logo">
        <a href="/">
          <img src={LOGO} alt="app-logo" />
        </a>
      </div>
      <div className={navOpen ? "navLinks" : "navLinks-Close"}>
        <a href="/">Home</a>
        <a href="/equipments">Equipment</a>
        {/* <a href="/services">Services & Solutions</a> */}
        <a href="/discover">Discover Us</a>
      </div>
      <div className="call-to-action">
        <button className="btn-primary">
          <a href="/contact-us">GET IN TOUCH</a>
        </button>
        <div className="hamburger" onClick={toggleNavbar}>
          <RxHamburgerMenu />
        </div>
      </div>
    </TheHeader>
  );
};

const TheHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background: white;
  .call-to-action a {
    color: white;
  }
  .logo {
    width: 15rem;
    overflow: hidden;
    img {
      width: 100%;
    }
  }
  .hamburger {
    display: none;
  }
  .navLinks,
  .navLinks-Close {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4rem;
    a {
      color: #000;
      font-weight: 400;
      transition: var(--transition);
      font-size: 1rem;
      &:hover {
        color: var(--primary-color);
      }
    }
  }
  @media screen and (max-width: 1366px) {
  }
  @media screen and (max-width: 1200px) {
  }
  @media screen and (max-width: 900px) {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    height: 8vh;
    z-index: 100;
    .logo {
      width: 9rem;
      overflow: hidden;
      margin-bottom: -0.5rem;
      img {
        width: 100%;
      }
    }
    .call-to-action {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 1rem;
    }
    .hamburger {
      display: block;
      font-size: 1.5rem;
      margin-bottom: -0.5rem;
      cursor: pointer;
      color: var(--primary-color);
    }
    .navLinks {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-direction: column;
      position: absolute;
      gap: 4rem;
      background: var(--primary-color);
      width: 100%;
      height: 92vh;
      top: 8vh;
      left: 0;
      padding-top: 5rem;
      transition: var(--transition);
      a {
        color: white;
        font-weight: 400;
        transition: var(--transition);
        font-size: 1rem;
        &:hover {
          color: var(--primary-color);
        }
      }
    }
    .navLinks-Close {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-direction: column;
      position: absolute;
      gap: 4rem;
      background: var(--primary-color);
      width: 100%;
      height: 92vh;
      top: 8vh;
      left: -100%;
      padding-top: 5rem;
      transition: var(--transition);
      a {
        color: white;
        font-weight: 400;
        transition: var(--transition);
        font-size: 1rem;
        &:hover {
          color: var(--primary-color);
        }
      }
    }
  }
  @media screen and (max-width: 600px) {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    height: 8vh;
    z-index: 100;
    .logo {
      width: 9rem;
      overflow: hidden;
      margin-bottom: -0.5rem;
      img {
        width: 100%;
      }
    }
    .call-to-action {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 1rem;
    }
    .hamburger {
      display: block;
      font-size: 1.5rem;
      margin-bottom: -0.5rem;
      cursor: pointer;
      color: var(--primary-color);
    }
    .navLinks {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-direction: column;
      position: absolute;
      gap: 3rem;
      background: var(--primary-color);
      width: 100%;
      height: 92vh;
      top: 8vh;
      left: 0;
      padding-top: 2rem;
      transition: var(--transition);
      a {
        color: white;
        font-weight: 400;
        transition: var(--transition);
        font-size: 1rem;
        &:hover {
          color: var(--primary-color);
        }
      }
    }
    .navLinks-Close {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-direction: column;
      position: absolute;
      gap: 3rem;
      background: var(--primary-color);
      width: 100%;
      height: 92vh;
      top: 8vh;
      left: -100%;
      padding-top: 2rem;
      transition: var(--transition);
      a {
        color: white;
        font-weight: 400;
        transition: var(--transition);
        font-size: 1rem;
        &:hover {
          color: var(--primary-color);
        }
      }
    }
  }
  @media screen and (max-width: 420px) {
  }
  @media screen and (max-width: 350px) {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 0.5rem;
    height: 8vh;
    z-index: 100;
    .logo {
      width: 8rem;
      overflow: hidden;
      margin-bottom: -0.5rem;
      img {
        width: 100%;
      }
    }
    .call-to-action {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 1rem;
    }
    .hamburger {
      display: block;
      font-size: 1.2rem;
      margin-bottom: -0.5rem;
      cursor: pointer;
      color: var(--primary-color);
    }
    .navLinks {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-direction: column;
      position: absolute;
      gap: 2rem;
      background: var(--primary-color);
      width: 100%;
      height: 92vh;
      top: 8vh;
      left: 0;
      padding-top: 2rem;
      transition: var(--transition);
      a {
        color: white;
        font-weight: 400;
        transition: var(--transition);
        font-size: 0.8rem;
        &:hover {
          color: var(--primary-color);
        }
      }
    }
    .navLinks-Close {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-direction: column;
      position: absolute;
      gap: 2rem;
      background: var(--primary-color);
      width: 100%;
      height: 92vh;
      top: 8vh;
      left: -100%;
      padding-top: 5rem;
      transition: var(--transition);
      a {
        color: white;
        font-weight: 400;
        transition: var(--transition);
        font-size: 0.8rem;
        &:hover {
          color: var(--primary-color);
        }
      }
    }
  }
`;
export default Header;
